import React from 'react';
import { motion } from 'framer-motion';
export function PricingHero() {
  return <section className="bg-brand-black px-4 pb-20 pt-10 text-center sm:px-6 lg:px-8 lg:pb-24 lg:pt-8" data-id="element-701" data-mp="2twv6e65pcfbd">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto max-w-4xl" data-id="element-702" data-mp="2f8ifvopdvoo9">
        <h1 className="text-5xl font-extrabold leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-7xl" data-id="element-703" data-mp="37we9ulnkj2hc">
          Pick the plan that fits
          <span className="block text-brand-red" data-id="element-704" data-mp="3cv7owiii71jm">your business.</span>
        </h1>
        <p className="mx-auto mt-8 max-w-2xl text-lg leading-relaxed text-gray-300 sm:text-xl" data-id="element-705" data-mp="2yvoko0stcacl">
          Every plan is AdROI working as your marketing department — traffic in, conversions out.
          Upgrade any time.
        </p>
      </motion.div>
    </section>;
}